// extracted by mini-css-extract-plugin
export default {"main":"About_main__USEJK","image":"About_image__eho55","anchor":"About_anchor__g2Re+"};